import React, { Component } from "react";
import Accordion from 'react-bootstrap/Accordion';

export default class Contact extends Component {
  render() {
    return (

      <div className="container">
        <h2>联系我们</h2>
        <p>电话：18228032916</p>
        <p>地址：四川省 成都市 双流区 和平路 9号</p>
        <a href="/culture">茶文化</a>
      </div>

    );
  }
}